<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          Purchase Orders &nbsp;
          <add-button
            link="/procurement-management/purchase-orders/create"
          ></add-button>
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Procurement Management</li>
          <li class="breadcrumb-item">Purchase Orders</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Search & Filtering  -->
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body row">
          <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
            <input
              type="text"
              class="form-control"
              placeholder="Search..."
              v-model="searchData"
              @keydown.enter="search"
            />
          </div>
          <!-- Export To Excel -->
          <div class="col-md-4">
            <div style="float: right">
              <a
                href="#"
                class="btn btn-primary"
                v-if="Exportpurchase_orders.length == 0"
                @click="exportToExcel"
              >
                <span v-if="isExcelloading">
                  <div class="d-flex align-items-center">
                    <strong>Generating Excel</strong>
                    &nbsp;
                    <div
                      class="
                        spinner-border
                        text-light
                        spinner-border-sm
                        ms-auto
                      "
                      role="status"
                      aria-hidden="true"
                    ></div>
                  </div>
                </span>
                <span v-else>Generate Excel</span>
              </a>
              <download-excel
                :title="title"
                v-else
                class="btn btn-success"
                :data="purchase_orders_excel"
                :fields="excel_fields"
                worksheet="Purchase Orders"
                name="Purchase Order.xls"
                >Download Excel
              </download-excel>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Search & Filtering  -->
    <!-- Table -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- <br /> -->
            <!-- End Export to Excel -->
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Quotation</th>
                    <th>Quotation date</th>
                    <th>Purchase Order Number</th>
                    <th>Delivery Order Number</th>
                    <th>Delivered date</th>
                    <th>Receipt Port</th>
                    <th>Remark</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Table Loader -->
                  <loading-table
                    :isLoading="isLoading"
                    cols="8
                        "
                  ></loading-table>
                  <!-- If No Data Received-->
                  <tr v-if="purchase_orders.length == 0">
                    <td colspan="8" class="text-center" style="color: grey">
                      No Data Found
                    </td>
                  </tr>
                  <!-- If data Received -->
                  <tr
                    v-for="(purchase_order, at) in purchase_orders"
                    :key="`purchase_order${at}`"
                  >
                    <td>{{ serialNoStarting + at + 1 }}</td>
                    <td>{{ purchase_order.quotation.quotation_no }}</td>
                    <td>
                      {{ purchase_order.quotation_date | ddmmyyyy }}
                    </td>
                    <td>
                      {{ purchase_order.po_no }}
                    </td>
                    <td>
                      {{ purchase_order.do_no }}
                    </td>
                    <td>
                      {{ purchase_order.delivered_in }}
                    </td>
                    <td>
                      {{ purchase_order.receipt_port_id }}
                    </td>
                    <td>
                      {{ purchase_order.remarks }}
                    </td>

                    <td>
                      <div>
                        <router-link
                          :to="`/procurement-management/purchase-orders/${purchase_order.id}`"
                          tag="button"
                          class="btn btn-primary btn-sm"
                          >Edit</router-link
                        >
                        &nbsp; &nbsp;
                        <button
                          class="btn btn-danger btn-sm"
                          @click="delete_data(purchase_order.id)"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <pagination :count="count" @submit="getData"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "purchase_order",
  data() {
    return {
      purchase_orders: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      isExcelloading: false,
      searchData: "",
      purchase_orders_excel: [],
      excel_fields: {
        "Sr No": "sr_no",
        Quotation: "quotation",
        "Quotation Date": "quotation_date",
        "Purchase Order Number": "po_no",
        "Delivered Order Number": "do_no",
        Remark: "remarks",
      },
      Exportpurchase_orders: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // async getData() {
    async getData(page = 1) {
      this.isLoading = true;
      let purchase_orders = await axios.get(
        `/purchase_orders?page=${page}&rowsPerPage=${this.rowsPerPage}`
      );
      this.purchase_orders = purchase_orders.data.data;
      this.count = purchase_orders.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async search() {
      this.isLoading = true;
      let purchase_orders = await axios.get(
        `/purchase_orders?search=${this.searchData}`
      );
      this.purchase_orders = purchase_orders.data.data;
      this.count = purchase_orders.data.count;
      this.isLoading = false;
    },
    async exportToExcel() {
      this.isExcelloading = true;
      this.title = "Purchase Order Data";
      this.purchase_orders_excel = [];
      let Exportpurchase_orders = [];
      Exportpurchase_orders = await axios.get(`/purchase_orders`);
      this.Exportpurchase_orders = Exportpurchase_orders.data.data;
      let sr_no = 1;
      this.Exportpurchase_orders.forEach((purchase_order) => {
        this.purchase_orders_excel.push({
          sr_no: sr_no,
          quotation: purchase_order.quotation
            ? purchase_order.quotation.quotation_no
            : "",
          quotation_date: purchase_order.quotation_date
            ? purchase_order.quotation_date
            : "",
          po_no: purchase_order.po_no ? purchase_order.po_no : "",
          do_no: purchase_order.do_no ? purchase_order.do_no : "",
          remarks: purchase_order.remarks ? purchase_order.remarks : "",
        });
        sr_no++;
      });
      this.isExcelloading = false;
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=purchase_orders`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
